export const UnreadType = [
    {
        label: 'All',
        value: -1,
    },
    {
        label: 'Unread Envelopes',
        value: 1,
    },
    {
        label: 'Unread Scans',
        value: 2,
    }
];

export const MailType = [
    {
        label: 'All',
        value: -1,
    },
    {
        label: 'Parcels',
        value: 0,
    },
    {
        label: 'Letters',
        value: 1,
    }
];

export const MailScanned = [
    {
        label: 'All',
        value: -1,
    },
    {
        label: 'Unopened',
        value: 0,
    },
    {
        label: 'Scanned',
        value: 1,
    }
];
